export default __webpack_public_path__ + "static/media/foulane-play-video.a5dd7f01.svg";